import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FamiliarCreatePage } from './familiar-create.page';

const routes: Routes = [
  {
    path: '',
    component: FamiliarCreatePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FamiliarCreatePageRoutingModule {}
